import React, { useState } from 'react';
import { CalendarIcon, CheckIcon, AlertCircleIcon, UserIcon, BuildingIcon, MailIcon, PhoneIcon, ChevronDownIcon, ChevronUpIcon, ClockIcon } from 'lucide-react';
const UpcomingPayments = () => {
  // Track expanded payment rows
  const [expandedPaymentIds, setExpandedPaymentIds] = useState<number[]>([]);
  // Mock customer details data - in a real app, this would come from an API
  const customerDetails = {
    'ABC Corporation': {
      name: 'ABC Corporation',
      contactPerson: 'John Smith',
      email: 'john.smith@abccorp.com',
      phone: '+1 (555) 123-4567',
      address: '123 Business Ave, Suite 500, New York, NY 10001',
      paymentTerms: 'Net 30',
      accountManager: 'Sarah Johnson'
    },
    'XYZ Industries': {
      name: 'XYZ Industries',
      contactPerson: 'Lisa Chen',
      email: 'lisa.chen@xyzindustries.com',
      phone: '+1 (555) 987-6543',
      address: '456 Tech Blvd, San Francisco, CA 94107',
      paymentTerms: 'Net 45',
      accountManager: 'Michael Brown'
    },
    'Global Enterprises': {
      name: 'Global Enterprises',
      contactPerson: 'Robert Garcia',
      email: 'r.garcia@globalenterprises.com',
      phone: '+1 (555) 456-7890',
      address: '789 International Way, Chicago, IL 60601',
      paymentTerms: 'Net 30',
      accountManager: 'Emily Wilson'
    },
    'Tech Solutions Inc.': {
      name: 'Tech Solutions Inc.',
      contactPerson: 'David Kim',
      email: 'david.kim@techsolutions.com',
      phone: '+1 (555) 234-5678',
      address: '101 Innovation Drive, Austin, TX 78701',
      paymentTerms: 'Net 15',
      accountManager: 'Jessica Martinez'
    },
    'Innovate Ltd.': {
      name: 'Innovate Ltd.',
      contactPerson: 'Amanda Taylor',
      email: 'a.taylor@innovateltd.com',
      phone: '+1 (555) 876-5432',
      address: '202 Future Street, Seattle, WA 98101',
      paymentTerms: 'Net 30',
      accountManager: 'Thomas Anderson'
    }
  };
  const upcomingPayments = [{
    id: 1,
    customer: 'ABC Corporation',
    amount: '$1,245.00',
    dueDate: '2023-07-15',
    invoiceNumber: 'INV-2023-001',
    status: 'Scheduled for payment',
    paymentMethod: 'Direct Deposit',
    timeline: [{
      status: 'Start LucaPay',
      date: '2023-06-15',
      completed: true
    }, {
      status: 'Credit check',
      date: '2023-06-18',
      completed: true
    }, {
      status: 'Approved',
      date: '2023-06-22',
      completed: true
    }, {
      status: 'Scheduled for payment',
      date: '2023-06-25',
      completed: true
    }]
  }, {
    id: 2,
    customer: 'XYZ Industries',
    amount: '$876.50',
    dueDate: '2023-07-18',
    invoiceNumber: 'INV-2023-002',
    status: 'Credit check',
    paymentMethod: 'Direct Deposit',
    timeline: [{
      status: 'Start LucaPay',
      date: '2023-06-18',
      completed: true
    }, {
      status: 'Credit check',
      date: '2023-06-22',
      completed: true
    }, {
      status: 'Approved',
      date: '2023-06-28',
      completed: false
    }, {
      status: 'Scheduled for payment',
      date: 'Pending',
      completed: false
    }]
  }, {
    id: 3,
    customer: 'Global Enterprises',
    amount: '$2,340.00',
    dueDate: '2023-07-22',
    invoiceNumber: 'INV-2023-003',
    status: 'Approved',
    paymentMethod: 'Direct Deposit',
    timeline: [{
      status: 'Start LucaPay',
      date: '2023-06-20',
      completed: true
    }, {
      status: 'Credit check',
      date: '2023-06-24',
      completed: true
    }, {
      status: 'Approved',
      date: '2023-06-28',
      completed: true
    }, {
      status: 'Scheduled for payment',
      date: '2023-07-05',
      completed: false
    }]
  }, {
    id: 4,
    customer: 'Tech Solutions Inc.',
    amount: '$945.00',
    dueDate: '2023-07-25',
    invoiceNumber: 'INV-2023-004',
    status: 'Start LucaPay',
    paymentMethod: 'Direct Deposit',
    timeline: [{
      status: 'Start LucaPay',
      date: '2023-06-25',
      completed: true
    }, {
      status: 'Credit check',
      date: 'Pending',
      completed: false
    }, {
      status: 'Approved',
      date: 'Pending',
      completed: false
    }, {
      status: 'Scheduled for payment',
      date: 'Pending',
      completed: false
    }]
  }, {
    id: 5,
    customer: 'Innovate Ltd.',
    amount: '$1,876.50',
    dueDate: '2023-07-30',
    invoiceNumber: 'INV-2023-005',
    status: 'Scheduled for payment',
    paymentMethod: 'Direct Deposit',
    timeline: [{
      status: 'Start LucaPay',
      date: '2023-06-22',
      completed: true
    }, {
      status: 'Credit check',
      date: '2023-06-25',
      completed: true
    }, {
      status: 'Approved',
      date: '2023-06-28',
      completed: true
    }, {
      status: 'Scheduled for payment',
      date: '2023-07-01',
      completed: true
    }]
  }];
  const toggleExpandPayment = (paymentId: number) => {
    setExpandedPaymentIds(prevIds => prevIds.includes(paymentId) ? prevIds.filter(id => id !== paymentId) : [...prevIds, paymentId]);
  };
  // Helper function to get status icon and color
  const getStatusInfo = (status: string) => {
    switch (status) {
      case 'Scheduled for payment':
        return {
          icon: <CheckIcon className="h-5 w-5 text-green-500" data-id="element-532" />,
          color: 'bg-green-100 text-green-800'
        };
      case 'Approved':
        return {
          icon: <CheckIcon className="h-5 w-5 text-blue-500" data-id="element-533" />,
          color: 'bg-blue-100 text-blue-800'
        };
      case 'Credit check':
        return {
          icon: <ClockIcon className="h-5 w-5 text-yellow-500" data-id="element-534" />,
          color: 'bg-yellow-100 text-yellow-800'
        };
      case 'Start LucaPay':
        return {
          icon: <AlertCircleIcon className="h-5 w-5 text-gray-500" data-id="element-535" />,
          color: 'bg-gray-100 text-gray-800'
        };
      default:
        return {
          icon: <AlertCircleIcon className="h-5 w-5 text-gray-500" data-id="element-536" />,
          color: 'bg-gray-100 text-gray-800'
        };
    }
  };
  return <div className="space-y-6" data-id="element-537">
      <div data-id="element-538">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-539">Upcoming Payments</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-540">
          View and manage your upcoming payments. Processed by LucaPay
        </p>
      </div>
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-541">
        <div className="px-4 py-5 sm:px-6 flex justify-between items-center" data-id="element-542">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-543">
            Scheduled Payments
          </h3>
          <div className="flex items-center space-x-2" data-id="element-544">
            <button className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-545">
              <CalendarIcon className="h-4 w-4 mr-1.5" data-id="element-546" />
              Calendar View
            </button>
          </div>
        </div>
        <div className="border-t border-gray-200" data-id="element-547">
          <ul className="divide-y divide-gray-200" data-id="element-548">
            {upcomingPayments.map(payment => {
            const isExpanded = expandedPaymentIds.includes(payment.id);
            const statusInfo = getStatusInfo(payment.status);
            return <li key={payment.id} className="border-b border-gray-200" data-id="element-549">
                  {/* Payment row - clickable to expand */}
                  <div className="px-4 py-4 sm:px-6 cursor-pointer hover:bg-gray-50" onClick={() => toggleExpandPayment(payment.id)} data-id="element-550">
                    <div className="flex items-center justify-between" data-id="element-551">
                      <div className="flex items-center" data-id="element-552">
                        <div className="flex-shrink-0" data-id="element-553">{statusInfo.icon}</div>
                        <div className="ml-3" data-id="element-554">
                          <p className="text-sm font-medium text-gray-900" data-id="element-555">
                            {payment.customer}
                          </p>
                          <p className="text-sm text-gray-500" data-id="element-556">
                            Due:{' '}
                            {new Date(payment.dueDate).toLocaleDateString()} |
                            Invoice: {payment.invoiceNumber}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center" data-id="element-557">
                        <div className="mr-4 flex flex-col items-end" data-id="element-558">
                          <p className="text-sm font-medium text-gray-900" data-id="element-559">
                            {payment.amount}
                          </p>
                          <p className="text-xs text-gray-500" data-id="element-560">
                            {payment.paymentMethod}
                          </p>
                        </div>
                        <div className="flex items-center" data-id="element-561">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${statusInfo.color}`} data-id="element-562">
                            {payment.status}
                          </span>
                          {isExpanded ? <ChevronUpIcon className="h-5 w-5 ml-2 text-gray-400" data-id="element-563" /> : <ChevronDownIcon className="h-5 w-5 ml-2 text-gray-400" data-id="element-564" />}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Expanded content with timeline */}
                  {isExpanded && <div className="px-4 py-4 sm:px-6 bg-gray-50 border-t border-gray-200" data-id="element-565">
                      <div className="flex space-x-8" data-id="element-566">
                        {/* Timeline section */}
                        <div className="flex-1" data-id="element-567">
                          <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-568">
                            Payment Timeline
                          </h4>
                          <div className="flow-root" data-id="element-569">
                            <ul className="-mb-8" data-id="element-570">
                              {/* Display timeline in reverse order (from bottom to top) */}
                              {[...payment.timeline].reverse().map((timelineItem, timelineIdx) => {
                          const isLast = timelineIdx === 0;
                          return <li key={timelineItem.status} data-id="element-571">
                                      <div className="relative pb-8" data-id="element-572">
                                        {!isLast && <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" data-id="element-573"></span>}
                                        <div className="relative flex space-x-3" data-id="element-574">
                                          <div data-id="element-575">
                                            <span className={`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white ${timelineItem.completed ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-576">
                                              {timelineItem.completed && <CheckIcon className="h-5 w-5 text-white" data-id="element-577" />}
                                            </span>
                                          </div>
                                          <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" data-id="element-578">
                                            <div data-id="element-579">
                                              <p className="text-sm text-gray-900" data-id="element-580">
                                                {timelineItem.status}
                                              </p>
                                            </div>
                                            <div className="text-right text-sm whitespace-nowrap text-gray-500" data-id="element-581">
                                              {timelineItem.date}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </li>;
                        })}
                            </ul>
                          </div>
                        </div>
                        {/* Customer details section */}
                        <div className="flex-1" data-id="element-582">
                          <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-583">
                            Customer Details
                          </h4>
                          <dl className="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2" data-id="element-584">
                            <div className="sm:col-span-1" data-id="element-585">
                              <dt className="text-xs font-medium text-gray-500" data-id="element-586">
                                Contact Person
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900 flex items-center" data-id="element-587">
                                <UserIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-588" />
                                {customerDetails[payment.customer].contactPerson}
                              </dd>
                            </div>
                            <div className="sm:col-span-1" data-id="element-589">
                              <dt className="text-xs font-medium text-gray-500" data-id="element-590">
                                Email
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900 flex items-center" data-id="element-591">
                                <MailIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-592" />
                                {customerDetails[payment.customer].email}
                              </dd>
                            </div>
                            <div className="sm:col-span-1" data-id="element-593">
                              <dt className="text-xs font-medium text-gray-500" data-id="element-594">
                                Phone
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900 flex items-center" data-id="element-595">
                                <PhoneIcon className="h-4 w-4 text-gray-400 mr-1" data-id="element-596" />
                                {customerDetails[payment.customer].phone}
                              </dd>
                            </div>
                            <div className="sm:col-span-1" data-id="element-597">
                              <dt className="text-xs font-medium text-gray-500" data-id="element-598">
                                Payment Terms
                              </dt>
                              <dd className="mt-1 text-sm text-gray-900" data-id="element-599">
                                {customerDetails[payment.customer].paymentTerms}
                              </dd>
                            </div>
                          </dl>
                          <div className="mt-4" data-id="element-600">
                            <button type="button" className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" onClick={() => {
                        // This would typically open an email or messaging interface
                        alert(`Contact ${customerDetails[payment.customer].contactPerson}`);
                      }} data-id="element-601">
                              Contact Customer
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>}
                </li>;
          })}
          </ul>
        </div>
      </div>
    </div>;
};
export default UpcomingPayments;